import { PaginationQueryParams } from '@/shared/schemas/pagination'

import { ITagRepository } from './tag.repository.interface'
import { UpdateTagSchema } from './tag.schema'
import { TagResponseDto, TagSearchByNameResponseDto } from './tag.types'

export class TagService {
  constructor(private tagRepository: ITagRepository) {}

  async getAll(): Promise<TagResponseDto[]> {
    return this.tagRepository.getAll()
  }

  async get(tagId: string, filters: PaginationQueryParams): Promise<TagResponseDto> {
    return this.tagRepository.get(tagId, filters)
  }

  async update(tagId: string, data: UpdateTagSchema): Promise<TagResponseDto> {
    return this.tagRepository.update(tagId, data)
  }

  async create(data: UpdateTagSchema): Promise<TagResponseDto> {
    return this.tagRepository.create(data)
  }

  async searchByName(name: string): Promise<TagSearchByNameResponseDto[]> {
    return this.tagRepository.searchByName(name)
  }
}
